import { RefObject, useEffect, useState } from "react"
import ResizeObserver from "resize-observer-polyfill"

export function useRenderedSize<E extends HTMLElement>(
    ref: RefObject<E>,
    initialSize: { width: number; height: number }
): { width: number; height: number } {
    const [size, setSize] = useState(initialSize)

    useEffect(() => {
        if (ref.current === null) {
            return
        }

        const observer = new ResizeObserver(() => {
            if (ref.current !== null) {
                setSize({
                    width: ref.current.offsetWidth,
                    height: ref.current.offsetHeight
                })
            }
        })

        observer.observe(ref.current)

        return () => observer.disconnect()
    }, [ref])

    return size
}
